import Experience from "@folio-2026/experience"
import { EVENTS } from "@folio-2026/shared"
import { ButtonEvent, TextScene } from "@folio-2026/text"
import { gsap } from "gsap/all"

import { useLoadingStore } from "./store"

export default class AboutCTA {
  experience: Experience
  textScene: TextScene
  id: string = "about-cta"
  private revealAboutCTATween?: gsap.core.Tween

  constructor({ textScene }: { textScene: TextScene }) {
    this.experience = Experience.getInstance()

    this.textScene = textScene

    this.setEventListeners()
  }

  setEventListeners() {
    this.experience.on(
      EVENTS.About.EnterCTA.Click,
      this.clickHandler.bind(this),
    )
    this.experience.on(
      EVENTS.About.EnterCTA.Hover,
      this.hoverHandler.bind(this),
    )
    this.experience.on(EVENTS.About.EnterCTA.Out, this.outHandler.bind(this))
  }

  hoverHandler(e: unknown) {
    if (this.experience.isMenuOpen) {
      return
    }
    const event = e as ButtonEvent
    const { htmlElement } = event

    if (htmlElement.id !== this.id) {
      return
    }

    useLoadingStore.getState().setHasEnterHover(true)
  }

  outHandler(e: unknown) {
    if (this.experience.isMenuOpen) {
      return
    }
    const event = e as ButtonEvent
    const { htmlElement } = event

    if (htmlElement.id !== this.id) {
      return
    }

    useLoadingStore.getState().setHasEnterHover(false)
  }

  clickHandler(e: unknown) {
    if (this.experience.isMenuOpen) {
      return
    }
    const event = e as ButtonEvent
    const { htmlElement } = event

    if (htmlElement.id !== this.id) {
      return
    }
    this.experience.navigate("/about")
  }

  revealAboutCTA() {
    const pathname = window.location.pathname
    if (pathname !== "/") {
      return
    }

    this.cancelRevealAboutCTA()

    const proxy = { progress: 0 }
    this.revealAboutCTATween = gsap.to(proxy, {
      progress: 1,
      duration: 1.5,
      onComplete: () => {
        this.revealAboutCTATween = undefined
        this.textScene.smallButtons
          .filter((button) => button.id === this.id)
          .forEach((button) => button.reveal())
      },
    })
  }

  cancelRevealAboutCTA() {
    if (this.revealAboutCTATween) {
      this.revealAboutCTATween.kill()
      this.revealAboutCTATween = undefined
      this.resetAboutCTA()
    }
  }

  leaveAboutCTA() {
    useLoadingStore.getState().setHasEnterHover(false)

    this.textScene.smallButtons
      .filter((button) => button.id === this.id)
      .forEach((button) => button.leave())
  }

  resetAboutCTA() {
    this.cancelRevealAboutCTA()
    this.textScene.smallButtons
      .filter((button) => button.id === this.id)
      .forEach((button) => button.resetToRevealStart())
  }
}
